import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Radio,
  Space,
  Checkbox,
  message,
  Spin,
  Input,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import {
  RESEARCH_TYPE,
  LE_STUDY_DEMOGRAPHICS_CONTENT,
} from "../../../../utils/consts";
import { translateApiMessage } from "../../../../utils/functions";
import moment from "moment";
import dayjs from "dayjs";
import englishJson from "../../../../utils/language/leStudy/english.json";
import spanishJson from "../../../../utils/language/leStudy/spanish.json";
import noLanguageJson from "../../../../utils/language/leStudy/noLanguage.json";
import { logEvent } from "../../../../utils/analytics";

const { Option } = Select;

export default class MedicalHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smoking_history: "",
      allergies: [
        {
          id: 1,
          name: "",
        },
      ],
      prescriptions: [],
      surgeries: [
        {
          id: 1,
          type: "",
          location: "",
          date: "",
        },
      ],
      diagnosed_hair_loss: "",
      anything_apply_to_you: [],
      loading: false,
      have_you_quit_smoking_in_the_past_year: "",
      do_you_have_allergies: "",
      // history
      bipolar_disorder: "",
      brain_aneurysm: "",
      cancer: "",
      depression: "",
      diabetes: "",
      epilepsy: "",
      muscle_disease: "",
      schizophrenia: "",
      migraines: "",

      adhd: "",
      anxiety: "",
      asthma: "",
      autism_spectrum_disorder: "",
      cognitive_impairment: "",
      concussion: "",
      copd: "",
      dementia: "",
      other_history_option: "",
      other_history_specification: "",

      participant_type: [],
      participant_type_als: "",
      participant_type_any_other_neurologic_diagnosis: "",
      participant_type_any_other_neurologic_diagnosis_other_specification: "",

      ecas_user_type: "",
      do_you_have_surgeries: "",
      do_you_have_prescription: "",

      enrolled_in_other_trials: "",
      trials: [],
      other_als_drug_history: "",
      als_drug_history: [],
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          let loadedPrescriptions = null;
          let drugHistory = [];

          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Prescriptions") {
                let prescriptions = item.value ? JSON.parse(item.value) : [];
                // Convert date strings to dayjs objects for DatePicker (Ant Design v5 works better with dayjs)
                loadedPrescriptions = prescriptions.map((prescription) => {
                  if (prescription.date_started) {
                    // Handle different date formats from backend
                    if (typeof prescription.date_started === "string") {
                      // Try parsing as ISO format first
                      let parsedDate = dayjs(prescription.date_started);
                      // If that fails, try MM/YYYY format
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(
                          prescription.date_started,
                          "MM/YYYY"
                        );
                      }
                      // If still invalid, try other common formats
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(
                          prescription.date_started,
                          "YYYY-MM"
                        );
                      }
                      // Only set if valid, normalized to start of month
                      if (parsedDate.isValid()) {
                        prescription.date_started = parsedDate.startOf("month");
                      } else {
                        prescription.date_started = null;
                      }
                    } else if (
                      prescription.date_started &&
                      typeof prescription.date_started.isValid === "function"
                    ) {
                      // Already a dayjs/moment object, ensure it's valid
                      if (prescription.date_started.isValid()) {
                        prescription.date_started = dayjs(
                          prescription.date_started
                        ).startOf("month");
                      } else {
                        prescription.date_started = null;
                      }
                    } else if (moment.isMoment(prescription.date_started)) {
                      // Convert moment to dayjs
                      if (prescription.date_started.isValid()) {
                        prescription.date_started = dayjs(
                          prescription.date_started
                        ).startOf("month");
                      } else {
                        prescription.date_started = null;
                      }
                    } else {
                      prescription.date_started = null;
                    }
                  } else {
                    prescription.date_started = null;
                  }
                  return prescription;
                });
              }
              if (item.field == "ALS Drug History") {
                // Handle both string and array formats from backend
                drugHistory = Array.isArray(item.value)
                  ? item.value
                  : item.value
                  ? typeof item.value === "string" && item.value.includes(",")
                    ? item.value.split(",").map((v) => v.trim())
                    : [item.value]
                  : [];
              }
              if (item.field == "Trial Details") {
                let trials = [];
                if (item.value) {
                  try {
                    trials = JSON.parse(item.value);
                    // If it's not an array, it might be old format (single string)
                    if (!Array.isArray(trials)) {
                      trials = [];
                    }
                  } catch (e) {
                    // If parsing fails, treat as empty array
                    trials = [];
                  }
                }
                // Convert date strings to dayjs objects normalized to start of month (Ant Design v5 works better with dayjs)
                let loadedTrials = trials.map((trial) => {
                  if (trial.date_enrolled) {
                    // Handle different date formats from backend
                    if (typeof trial.date_enrolled === "string") {
                      // Try parsing as ISO format first
                      let parsedDate = dayjs(trial.date_enrolled);
                      // If that fails, try MM/YYYY format
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(trial.date_enrolled, "MM/YYYY");
                      }
                      // If still invalid, try other common formats
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(trial.date_enrolled, "YYYY-MM");
                      }
                      // Store as dayjs object normalized to start of month if valid
                      if (parsedDate.isValid()) {
                        trial.date_enrolled = parsedDate.startOf("month");
                      } else {
                        trial.date_enrolled = null;
                      }
                    } else if (
                      trial.date_enrolled &&
                      typeof trial.date_enrolled.isValid === "function"
                    ) {
                      // Already a dayjs/moment object, ensure it's valid and normalized
                      if (trial.date_enrolled.isValid()) {
                        trial.date_enrolled = dayjs(
                          trial.date_enrolled
                        ).startOf("month");
                      } else {
                        trial.date_enrolled = null;
                      }
                    } else if (moment.isMoment(trial.date_enrolled)) {
                      // Convert moment to dayjs
                      if (trial.date_enrolled.isValid()) {
                        trial.date_enrolled = dayjs(
                          trial.date_enrolled
                        ).startOf("month");
                      } else {
                        trial.date_enrolled = null;
                      }
                    } else {
                      trial.date_enrolled = null;
                    }
                  } else {
                    trial.date_enrolled = null;
                  }
                  return trial;
                });
                this.setState({ trials: loadedTrials });
              }
              if (
                item.field ==
                "Currently Enrolled in other interventional clinical trials"
              ) {
                this.setState({ enrolled_in_other_trials: item.value });
              }
              if (item.field == "Other Drug") {
                this.setState({ other_als_drug_history: item.value });
              }
            }
          }

          // Set drug history first
          this.setState({ als_drug_history: drugHistory });

          // If prescriptions were loaded from backend, use them; otherwise sync from drug history
          if (loadedPrescriptions && loadedPrescriptions.length > 0) {
            this.setState({ prescriptions: loadedPrescriptions });
          } else if (drugHistory && drugHistory.length > 0) {
            // Only sync if no prescriptions were loaded
            this.syncPrescriptionsFromDrugHistory(drugHistory);
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  syncPrescriptionsFromDrugHistory = (selectedDrugs) => {
    if (!selectedDrugs || selectedDrugs.length === 0) {
      this.setState({ prescriptions: [] });
      return;
    }

    // Filter out "Other" from the list as it's handled separately
    const drugsToCreate = selectedDrugs.filter((drug) => drug !== "Other");

    // Get current prescriptions
    const currentPrescriptions = this.state.prescriptions || [];

    // Create a map of existing prescription names
    const existingDrugNames = new Set(
      currentPrescriptions.map((p) => p.name).filter((name) => name)
    );

    // Create new prescriptions for drugs that don't exist yet
    const newPrescriptions = [];
    drugsToCreate.forEach((drugName) => {
      if (!existingDrugNames.has(drugName)) {
        newPrescriptions.push({
          id: this.getRandomInt(1, 2000),
          name: drugName,
          dose: "",
          frequency: "",
          frequency_type: "",
          date_started: "",
          reason: "",
          units: "",
          unit_type: "",
          route: "",
          route_type: "",
          other_unit_type: "",
          other_route_type: "",
          other_frequency_type: "",
        });
      }
    });

    // Remove prescriptions for drugs that are no longer selected
    const filteredPrescriptions = currentPrescriptions.filter(
      (prescription) => {
        // Keep if it's in the selected drugs list or if it's a manually added prescription (not in the drug options)
        return (
          drugsToCreate.includes(prescription.name) ||
          !prescription.name ||
          this.isManuallyAddedPrescription(prescription.name)
        );
      }
    );

    // Combine filtered existing prescriptions with new ones
    this.setState({
      prescriptions: [...filteredPrescriptions, ...newPrescriptions],
    });
  };
  isManuallyAddedPrescription = (prescriptionName) => {
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    const drugOptions =
      formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.alsDrugHistoryOptions.map(
        (item) => item.value
      );
    return !drugOptions.includes(prescriptionName);
  };
  add_new_prescription = () => {
    let arr = this.state.prescriptions || [];
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      name: "",
      dose: "",
      frequency: "",
      frequency_type: "",
      date_started: "",
      reason: "",
      units: "",
      unit_type: "",
      route: "",
      route_type: "",
      other_unit_type: "",
      other_route_type: "",
      other_frequency_type: "",
    };
    arr.push(obj);
    this.setState({ prescriptions: arr });
  };
  remove_prescription = (id) => {
    const arr = this.state.prescriptions || [];
    const removed = arr.find((item) => item.id === id);
    const updatedPrescriptions = arr.filter((item) => item.id !== id);

    let updatedDrugHistory = this.state.als_drug_history || [];
    if (
      removed &&
      removed.name &&
      !this.isManuallyAddedPrescription(removed.name) &&
      updatedDrugHistory.includes(removed.name)
    ) {
      updatedDrugHistory = updatedDrugHistory.filter(
        (drug) => drug !== removed.name
      );
    }

    this.setState({
      prescriptions: updatedPrescriptions,
      als_drug_history: updatedDrugHistory,
    });
  };
  update_prescription = (event, item, field) => {
    let arr = this.state.prescriptions || [];
    let tempArr = arr.map((single) => {
      if (single.id === item.id) {
        let updated = { ...single };
        if (field == "name") {
          updated.name = event.target.value;
        } else if (field == "dose") {
          updated.dose = event.target.value;
        } else if (field == "units") {
          updated.units = event.target.value;
        } else if (field == "unit_type") {
          updated.unit_type = event.target.value;
        } else if (field == "other_unit_type") {
          updated.other_unit_type = event.target.value;
        } else if (field == "route") {
          updated.route = event.target.value;
        } else if (field == "route_type") {
          updated.route_type = event.target.value;
        } else if (field == "other_route_type") {
          updated.other_route_type = event.target.value;
        } else if (field == "frequency") {
          updated.frequency = event.target.value;
        } else if (field == "frequency_type") {
          updated.frequency_type = event.target.value;
        } else if (field == "other_frequency_type") {
          updated.other_frequency_type = event.target.value;
        } else if (field == "date_started") {
          // Store dayjs object normalized to start of month for month picker (Ant Design v5 works better with dayjs)
          if (event && event.isValid && event.isValid()) {
            updated.date_started = dayjs(event).startOf("month");
          } else {
            updated.date_started = null;
          }
        } else if (field == "reason") {
          updated.reason = event.target.value;
        }
        return updated;
      }
      return single;
    });
    this.setState({ prescriptions: tempArr });
  };
  add_new_trial = () => {
    let arr = this.state.trials || [];
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      trial_name: "",
      date_enrolled: null,
      trial_description: "",
      duration_in_trial: "",
    };
    arr.push(obj);
    this.setState({ trials: arr });
  };
  remove_trial = (id) => {
    let arr = this.state.trials || [];
    let tempArr = arr.filter((item) => item.id !== id);
    this.setState({ trials: tempArr });
  };
  update_trial = (event, item, field) => {
    let arr = this.state.trials || [];
    let tempArr = arr.map((single) => {
      if (single.id === item.id) {
        let updated = { ...single };
        if (field == "trial_name") {
          updated.trial_name = event.target.value;
        } else if (field == "date_enrolled") {
          // Store dayjs object normalized to start of month for month picker (Ant Design v5 works better with dayjs)
          if (event && event.isValid && event.isValid()) {
            updated.date_enrolled = dayjs(event).startOf("month");
          } else {
            updated.date_enrolled = null;
          }
        } else if (field == "trial_description") {
          updated.trial_description = event.target.value;
        } else if (field == "duration_in_trial") {
          updated.duration_in_trial = event.target.value;
        }
        return updated;
      }
      return single;
    });
    this.setState({ trials: tempArr });
  };
  // goToNextStep: true = Save & Next (validate + navigate), false = Save for later (no validation, redirect)
  save = (goToNextStep = true) => {
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;

    // Validation only for Save & Next
    if (goToNextStep) {
      if (
        !this.state.als_drug_history ||
        this.state.als_drug_history.length === 0
      ) {
        message.warning(formData.page.demographicQuestions.messages.validation.alsDrugHistoryRequired);
        return;
      }
      if (!this.state.enrolled_in_other_trials) {
        message.warning(
          formData.page.demographicQuestions.messages.validation.enrolledInOtherTrialsRequired
        );
        return;
      }
      // Validate trial name if enrolled in other trials is Yes
      if (this.state.enrolled_in_other_trials === "Yes") {
        if (!this.state.trials || this.state.trials.length === 0) {
          message.warning(
            formData.page.demographicQuestions.messages.validation.trialNameRequired
          );
          return;
        }
        for (let trial of this.state.trials) {
          if (!trial.trial_name || trial.trial_name.trim() === "") {
            message.warning(
              formData.page.demographicQuestions.messages.validation.trialNameRequired
            );
            return;
          }
        }
      }
      // Validate prescriptions - only medication name is required
      if (this.state.prescriptions && this.state.prescriptions.length > 0) {
        for (let prescription of this.state.prescriptions) {
          if (!prescription.name || prescription.name.trim() === "") {
            message.warning(formData.page.demographicQuestions.messages.validation.medicationNameRequired);
            return;
          }
        }
      }
    }

    const saveForLater = !goToNextStep;

    let missingFields = [];
    if (!this.state.als_drug_history || this.state.als_drug_history.length === 0) missingFields.push("ALS Drug History");
    if (!this.state.enrolled_in_other_trials) missingFields.push("Currently Enrolled in other interventional clinical trials");
    else if (this.state.enrolled_in_other_trials === "Yes") {
      if (!this.state.trials || this.state.trials.length === 0) missingFields.push("Trial Name");
      else {
        let trialMissing = false;
        for (let trial of this.state.trials) {
          if (!trial.trial_name || trial.trial_name.trim() === "") {
            trialMissing = true;
          }
        }
        if (trialMissing) missingFields.push("Trial Name");
      }
    }
    if (this.state.prescriptions && this.state.prescriptions.length > 0) {
      let prescriptionMissing = false;
      for (let prescription of this.state.prescriptions) {
        if (!prescription.name || prescription.name.trim() === "") {
          prescriptionMissing = true;
        }
      }
      if (prescriptionMissing) missingFields.push("Medication Name");
    }

    const isMedicalHistoryComplete = missingFields.length === 0 ? 1 : 0;

    const relationToAls =
      this.state.relation_to_als ||
      localStorage.getItem("ap_relation_to_als") ||
      "";
    // Both "Living with ALS" and "Caregiver" use this form; value is 1 when complete, 0 otherwise
    const medicalHistoryValue =
      relationToAls === "Living with ALS" || relationToAls === "Caregiver"
        ? isMedicalHistoryComplete
        : 0;

    let questions = [
      ...(saveForLater
        ? [
            {
              parent_field: "Save",
              field: "Save for later date",
              value: dayjs().format("MM/DD/YYYY HH:mm"),
            },
          ]
        : []),
      {
        parent_field: "Medical History Save Type",
        field: "Medical History Save Type",
        value: saveForLater ? "Save for Later" : "Save Medical History",
      },
      {
        parent_field: "Is Medical History Fields Submitted",
        field: "Is Medical History Fields Submitted",
        value: medicalHistoryValue,
      },
      {
        parent_field: "Medical History Missing Fields",
        field: "Medical History Missing Fields",
        value: JSON.stringify(missingFields),
      },
      {
        parent_field: "ALS Drug History",
        field: "ALS Drug History",
        value: Array.isArray(this.state.als_drug_history)
          ? this.state.als_drug_history.join(", ")
          : this.state.als_drug_history,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "alsDrugHistory"
          )?.content.find(
            (item) => item.subtitle == this.state.als_drug_history
          )?.subId || "",
      },
      {
        parent_field: "Prescriptions",
        field: "Prescriptions",
        value: JSON.stringify(
          (this.state.prescriptions || []).map((prescription) => ({
            ...prescription,
            date_started: prescription.date_started
              ? dayjs(prescription.date_started).format("MM/YYYY")
              : "",
          }))
        ),
      },
      {
        parent_field: "Trial Details",
        field: "Trial Details",
        value: JSON.stringify(
          (this.state.trials || []).map((trial) => ({
            ...trial,
            date_enrolled: trial.date_enrolled
              ? dayjs(trial.date_enrolled).format("MM/YYYY")
              : null,
          }))
        ),
      },
      {
        parent_field:
          "Currently Enrolled in other interventional clinical trials", //d
        field: "Currently Enrolled in other interventional clinical trials",
        value: this.state.enrolled_in_other_trials,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "currentlyEnrolledInOtherTrials"
          )?.content.find(
            (item) => item.subtitle == this.state.enrolled_in_other_trials
          )?.subId || "",
      },
      {
        parent_field: "Other Drug", //d
        field: "Other Drug",
        value: this.state.other_als_drug_history,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "5",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "medical_history" });
          const formData =
            RESEARCH_TYPE === "LE Study"
              ? this.props.language === "English"
                ? englishJson
                : this.props.language === "Spanish"
                  ? spanishJson
                  : noLanguageJson
              : englishJson;
          message.success(
            formData.page.demographicQuestions.messages
              .demographicsDataAddedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                setTimeout(() => {
                  window.location.assign("/dashboard");
                }, 3000);
              }
            }
          );
        } else {
          const language = this.props.language || "English";
          message.error(translateApiMessage(response.data.message, language));
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };

  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment();
    };
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    return (
      <div>
        <div className="header">
          <h3>
            {
              formData.page.demographicQuestions.fields.medicalHistory
                .innerTitle
            }
          </h3>
          <div className="white-block"></div>
        </div>
        {this.props.language ? (
          <Spin spinning={this.state.loading}>
            <div className="form-fields">
            <p className="manadatory-note">
              <strong className="text-danger">Note:</strong>
              {formData.page.demographicQuestions.allFieldsMandatory}
            </p>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.medicalHistory
                    .livingWithALS.alsDrugHistory
                }
              </label>
              <br />
              <div
                style={{
                  width: "100%",
                  maxWidth: 500,
                }}
              >
                <Select
                  mode="multiple"
                  onChange={(value) => {
                    this.setState(
                      {
                        als_drug_history: value,
                      },
                      () => {
                        // Auto-populate prescriptions when drugs are selected
                        this.syncPrescriptionsFromDrugHistory(value);
                      }
                    );
                  }}
                  value={this.state.als_drug_history}
                  className="col-lg-12 als-drug-select"
                  placeholder={formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.placeholders.selectAlsDrugs}
                  style={{
                    width: "100%",
                  }}
                  allowClear
                  maxTagCount={2}
                  maxTagPlaceholder={(omittedValues) =>
                    `+${omittedValues.length} more`
                  }
                >
                  {formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.alsDrugHistoryOptions.map(
                    (item, index) => {
                      return (
                        <Option value={item.value} key={index}>
                          {item.label}
                        </Option>
                      );
                    }
                  )}
                </Select>
              </div>
              {this.state.als_drug_history &&
                this.state.als_drug_history.includes("Other") && (
                  <div className="mt-3">
                    <label className="mb-2 input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .livingWithALS.otherSpecification
                      }
                    </label>
                    <br />
                    <Input
                      onChange={(e) =>
                        this.setState({
                          other_als_drug_history: e.target.value,
                        })
                      }
                      value={this.state.other_als_drug_history}
                      className="demographics-field-height mb-0"
                    />
                  </div>
                )}
            </div>
            {this.state.als_drug_history &&
              this.state.als_drug_history.length > 0 &&
              this.state.als_drug_history.filter((drug) => drug !== "Other")
                .length > 0 && (
                <div className="form-group">
                  <div className="d-flex justify-content-between col-lg-12">
                    <label className="mb-2 input-heading">
                      {formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.whatAreYourCurrentPrescriptions}
                    </label>
                    <button
                      className="add_row_button"
                      onClick={() => this.add_new_prescription()}
                      style={{
                        padding: "6px 12px",
                        fontSize: "14px",
                        marginBottom: "10px",
                      }}
                    >
                      <box-icon name="plus-circle" color="#fff"></box-icon>
                      &nbsp;&nbsp;{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.add}
                    </button>
                  </div>
                  <div className="col-lg-12 mt-3">
                    <table className="medical-history-table">
                      <thead>
                        <tr>
                          <th style={{ width: 250 }}>
                            {formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.medication}<span className="text-danger">*</span>
                          </th>
                          <th style={{ width: 50 }}>{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.dose}</th>
                          <th style={{ width: 80 }}>{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.units}</th>
                          <th style={{ width: 60 }}>{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.route}</th>
                          <th style={{ width: 60 }}>{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.frequency}</th>
                          <th style={{ width: 120 }}>{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.startDate}</th>
                          <th style={{ width: 30 }}>{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.reason}</th>
                          <th style={{ width: 60 }}>
                            {formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.prescriptionsTableHeadings.action}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.prescriptions.map((item, index) => {
                          return (
                            <tr key={item.id || index}>
                              <td style={{ padding: "0px 10px" }}>
                                <input
                                  type="text"
                                  value={item.name}
                                  className="medication-input"
                                  style={{ height: 35, width: "100%" }}
                                  onChange={(e) =>
                                    this.update_prescription(e, item, "name")
                                  }
                                />
                              </td>
                              <td style={{ padding: "0px 10px" }}>
                                <input
                                  type="text"
                                  value={item.dose}
                                  style={{ height: 35, width: "100%" }}
                                  onChange={(e) =>
                                    this.update_prescription(e, item, "dose")
                                  }
                                />
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <input
                                    type="text"
                                    value={item.units}
                                    style={{
                                      width: 100,
                                      height: 35,
                                      marginRight: 6,
                                    }}
                                    onChange={(e) =>
                                      this.update_prescription(e, item, "units")
                                    }
                                  />
                                  <select
                                    value={item.unit_type}
                                    onChange={(e) =>
                                      this.update_prescription(
                                        e,
                                        item,
                                        "unit_type"
                                      )
                                    }
                                    className="form-control px-2 mb-0"
                                    style={{
                                      width: 100,
                                      fontSize: 14,
                                      height: 35,
                                      maxHeight: 35,
                                      marginTop: 5,
                                    }}
                                  >
                                    <option value="">{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.placeholders.select}</option>
                                    <option value="mg">Mg</option>
                                    <option value="gm">Gm</option>
                                    <option value="ug/mcg">Ug/mcg</option>
                                    <option value="ml">mL</option>
                                    <option value="units">Units</option>
                                    <option value="tabs/caps">Tabs/Caps</option>
                                    <option value="drop">Drop</option>
                                    <option value="sprays">Sprays</option>
                                    <option value="other">Other</option>
                                  </select>
                                  {(item.unit_type === "other" ||
                                    item.unit_type === "Other") && (
                                    <input
                                      type="text"
                                      value={item.other_unit_type || ""}
                                      onChange={(e) =>
                                        this.update_prescription(
                                          e,
                                          item,
                                          "other_unit_type"
                                        )
                                      }
                                      placeholder={formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.placeholders.enterUnit}
                                      className="form-control px-2 mt-2 mb-0"
                                      style={{
                                        width: 100,
                                        fontSize: 14,
                                        height: 35,
                                        maxHeight: 35,
                                      }}
                                    />
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <input
                                    type="text"
                                    value={item.route}
                                    style={{
                                      width: 100,
                                      height: 35,
                                      marginRight: 6,
                                    }}
                                    onChange={(e) =>
                                      this.update_prescription(e, item, "route")
                                    }
                                  />
                                  <select
                                    value={item.route_type}
                                    onChange={(e) =>
                                      this.update_prescription(
                                        e,
                                        item,
                                        "route_type"
                                      )
                                    }
                                    className="form-control px-2 mb-0"
                                    style={{
                                      width: 100,
                                      fontSize: 14,
                                      height: 35,
                                      maxHeight: 35,
                                      marginTop: 5,
                                    }}
                                  >
                                    <option value="">{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.placeholders.select}</option>
                                    <option value="po">po</option>
                                    <option value="sl">sl</option>
                                    <option value="sc">sc</option>
                                    <option value="im">im</option>
                                    <option value="iv">iv</option>
                                    <option value="pr">pr</option>
                                    <option value="td">td</option>
                                    <option value="other">other</option>
                                  </select>
                                  {(item.route_type === "other" ||
                                    item.route_type === "Other") && (
                                    <input
                                      type="text"
                                      value={item.other_route_type || ""}
                                      onChange={(e) =>
                                        this.update_prescription(
                                          e,
                                          item,
                                          "other_route_type"
                                        )
                                      }
                                      placeholder={formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.placeholders.enterRoute}
                                      className="form-control px-2 mt-2 mb-0"
                                      style={{
                                        width: 100,
                                        fontSize: 14,
                                        height: 35,
                                        maxHeight: 35,
                                      }}
                                    />
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <input
                                    type="number"
                                    min="0"
                                    value={item.frequency}
                                    style={{
                                      height: 35,
                                      width: 100,
                                      marginRight: 6,
                                      marginBottom: 4,
                                    }}
                                    onChange={(e) =>
                                      this.update_prescription(
                                        e,
                                        item,
                                        "frequency"
                                      )
                                    }
                                  />
                                  <select
                                    value={item.frequency_type}
                                    onChange={(e) =>
                                      this.update_prescription(
                                        e,
                                        item,
                                        "frequency_type"
                                      )
                                    }
                                    className="form-control px-2 mb-0"
                                    style={{
                                      width: 100,
                                      fontSize: 14,
                                      height: 35,
                                      maxHeight: 35,
                                      marginTop: 5,
                                    }}
                                  >
                                    <option value="">{formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.placeholders.select}</option>
                                    <option value="qd">qd</option>
                                    <option value="bid">bid</option>
                                    <option value="tid">tid</option>
                                    <option value="qid">qid</option>
                                    <option value="qod">qod</option>
                                    <option value="prn">prn</option>
                                    <option value="other">other</option>
                                  </select>
                                  {(item.frequency_type === "other" ||
                                    item.frequency_type === "Other") && (
                                    <input
                                      type="text"
                                      value={item.other_frequency_type || ""}
                                      onChange={(e) =>
                                        this.update_prescription(
                                          e,
                                          item,
                                          "other_frequency_type"
                                        )
                                      }
                                      placeholder={formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.placeholders.enterFrequency}
                                      className="form-control px-2 mt-2 mb-0"
                                      style={{
                                        width: 100,
                                        fontSize: 14,
                                        height: 35,
                                        maxHeight: 35,
                                      }}
                                    />
                                  )}
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: "0px 10px",
                                  position: "relative",
                                }}
                              >
                                <DatePicker
                                  onChange={(date, dateString) =>
                                    this.update_prescription(
                                      date,
                                      item,
                                      "date_started"
                                    )
                                  }
                                  format={"MM/YYYY"}
                                  picker="month"
                                  value={
                                    item.date_started &&
                                    item.date_started.isValid &&
                                    item.date_started.isValid()
                                      ? dayjs(item.date_started)
                                      : undefined
                                  }
                                  placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectMonth}
                                  style={{
                                    width: "100%",
                                    height: 35,
                                    maxWidth: 500,
                                  }}
                                  getPopupContainer={() => document.body}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  value={item.reason}
                                  style={{ width: 120, height: 35 }}
                                  onChange={(e) =>
                                    this.update_prescription(e, item, "reason")
                                  }
                                />
                              </td>
                              <td>
                                <center>
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.remove_prescription(item.id)
                                    }
                                  >
                                    <box-icon
                                      size={"20px"}
                                      name="trash"
                                      color="red"
                                    ></box-icon>
                                  </span>
                                </center>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-12">
                <label className="mb-2 input-heading">
                  {
                    formData.page.demographicQuestions.fields.medicalHistory
                      .livingWithALS.currentlyEnrolledInOtherTrials
                  }
                  &nbsp;
                </label>
              </div>
              <div className="form-group mt-3">
                <Radio.Group
                  onChange={(e) => {
                    if (e.target.value === "Yes") {
                      // If no trials exist, initialize with one empty trial
                      const currentTrials = this.state.trials || [];
                      const trialsToSet =
                        currentTrials.length === 0
                          ? [
                              {
                                id: this.getRandomInt(1, 2000),
                                trial_name: "",
                                date_enrolled: null,
                                trial_description: "",
                                duration_in_trial: "",
                              },
                            ]
                          : currentTrials;
                      this.setState({
                        enrolled_in_other_trials: e.target.value,
                        trials: trialsToSet,
                      });
                    } else {
                      this.setState({
                        enrolled_in_other_trials: e.target.value,
                        trials: [],
                      });
                    }
                  }}
                  value={this.state.enrolled_in_other_trials}
                >
                  {formData.page.demographicQuestions.fields.medicalHistory.livingWithALS.yesNoOptions.map(
                    (item, index) => {
                      return (
                        <Radio value={item.value} key={index}>
                          {item.label}
                        </Radio>
                      );
                    }
                  )}
                </Radio.Group>
              </div>
              {this.state.enrolled_in_other_trials === "Yes" && (
                <div className="form-group mt-3">
                  <div className="d-flex justify-content-between col-lg-12">
                    <label className="mb-2 input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .livingWithALS.clinicalTrialSectionLabel
                      }
                    </label>
                    <button
                      type="button"
                      className="add_row_button"
                      onClick={() => this.add_new_trial()}
                      style={{
                        padding: "6px 12px",
                        fontSize: "14px",
                        marginBottom: "10px",
                      }}
                    >
                      <box-icon name="plus-circle" color="#fff"></box-icon>
                      &nbsp;&nbsp;
                      {formData.page.demographicQuestions.fields.medicalHistory
                        .livingWithALS.clinicalTrialAddButton || "Add"}
                    </button>
                  </div>
                  <div className="col-lg-12 mt-3">
                    <table className="medical-history-table">
                      <thead>
                        <tr>
                          <th>
                            {
                              formData.page.demographicQuestions.fields
                                .medicalHistory.livingWithALS
                                .clinicalTrialTableHeadings.trialName
                            }
                            <span className="text-danger">*</span>
                          </th>
                          <th>
                            {
                              formData.page.demographicQuestions.fields
                                .medicalHistory.livingWithALS
                                .clinicalTrialTableHeadings.dateEnrolled
                            }
                          </th>
                          <th>
                            {
                              formData.page.demographicQuestions.fields
                                .medicalHistory.livingWithALS
                                .clinicalTrialTableHeadings.trialDescription
                            }
                          </th>
                          <th>
                            {
                              formData.page.demographicQuestions.fields
                                .medicalHistory.livingWithALS
                                .clinicalTrialTableHeadings.durationInTrial
                            }
                          </th>
                          <th style={{ width: 60 }}>
                            {
                              formData.page.demographicQuestions.fields
                                .medicalHistory.livingWithALS
                                .clinicalTrialTableHeadings.action
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.trials.map((item, index) => {
                          return (
                            <tr key={item.id || index}>
                              <td style={{ padding: "8px 10px" }}>
                                <input
                                  type="text"
                                  value={item.trial_name}
                                  style={{ height: 35, width: "100%" }}
                                  onChange={(e) =>
                                    this.update_trial(e, item, "trial_name")
                                  }
                                />
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  position: "relative",
                                }}
                              >
                                <DatePicker
                                  onChange={(date) => {
                                    this.update_trial(
                                      date,
                                      item,
                                      "date_enrolled"
                                    );
                                  }}
                                  format={"MM/YYYY"}
                                  picker="month"
                                  value={
                                    item.date_enrolled &&
                                    item.date_enrolled.isValid &&
                                    item.date_enrolled.isValid()
                                      ? dayjs(item.date_enrolled)
                                      : item.date_enrolled &&
                                        typeof item.date_enrolled === "string"
                                      ? dayjs(
                                          item.date_enrolled,
                                          "MM/YYYY"
                                        ).isValid()
                                        ? dayjs(
                                            item.date_enrolled,
                                            "MM/YYYY"
                                          ).startOf("month")
                                        : undefined
                                      : undefined
                                  }
                                  placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectMonth}
                                  style={{
                                    width: "100%",
                                    height: 35,
                                    maxWidth: 500,
                                  }}
                                  allowClear={false}
                                  getPopupContainer={() => document.body}
                                />
                              </td>
                              <td style={{ padding: "8px 10px" }}>
                                <input
                                  type="text"
                                  value={item.trial_description}
                                  style={{ height: 35, width: "100%" }}
                                  onChange={(e) =>
                                    this.update_trial(
                                      e,
                                      item,
                                      "trial_description"
                                    )
                                  }
                                />
                              </td>
                              <td style={{ padding: "8px 10px" }}>
                                <input
                                  type="text"
                                  value={item.duration_in_trial}
                                  style={{ height: 35, width: "100%" }}
                                  onChange={(e) =>
                                    this.update_trial(
                                      e,
                                      item,
                                      "duration_in_trial"
                                    )
                                  }
                                />
                              </td>
                              <td style={{ textAlign: "center", width: 60 }}>
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.remove_trial(item.id || index)
                                  }
                                >
                                  <box-icon
                                    size={"20px"}
                                    name="trash"
                                    color="red"
                                  ></box-icon>
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(false)}
                >
                  {formData.page.demographicQuestions.button.saveForLater}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  {formData.page.demographicQuestions.button.save}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(4)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.demographicQuestions.button.previous}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(false)}
                >
                  {formData.page.demographicQuestions.button.saveForLater}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  Final save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
            </div>
          </Spin>
        ) : (
          <div className="form-fields">
            <div style={{ textAlign: "center", padding: "50px" }}>
              <Spin size="large" />
            </div>
            <div className="white-block"></div>
          </div>
        )}
      </div>
    );
  }
}
